import React from 'react';
import $ from 'jquery';
import Hls from 'hls.js';
import AppsIcon from '@material-ui/icons/Apps';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';

class MultiVideoArea extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMulti: false,
      setupVideo: false,
      hlses: []
    };
  }

  handleMouseEnterOrMouseMove = (e) => {
    //e.preventDefault(); // controlsが表示されなくなるのでcancelしない
    this.props.onOverlayFixed(true);
  };
  handleMouseLeave = (e) => {
    //e.preventDefault(); // controlsが表示されなくなるのでcancelしない
    if (!this.state.open) {
      this.props.onOverlayFixed(false);
    }
  };

  handleMultiButtonClick = () => {
    let isMulti = !this.state.isMulti;
    this.setState({isMulti: isMulti});
    if (this.state.isMulti) {
      this.setupVideo();
    } else {
      this.setState({setupVideo: false});
      this.releaseVideo();
    }
    this.props.onMultiModeChange(isMulti);
  };
  handleFullscreenButtonClick = () => {
    var el = document.getElementById('multi-video');
    if (el.requestFullscreen) {
      el.requestFullscreen();
    } else if (el.mozRequestFullScreen) {
      el.mozRequestFullScreen();
    } else if (el.webkitRequestFullscreen) {
      el.webkitRequestFullscreen();
    } else if (el.msRequestFullscreen) {
      el.msRequestFullscreen();
    }
  };
  handleCloseButtonClick = () => {
    this.handleMultiButtonClick();
  };
  handleItemClick = (service) => {
    this.props.onSelectChannel(service);
  };
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.services) {
      this.setState({services: nextProps.services.services});
    }
    if (this.state.isMulti) {
      this.setupVideo();
    }
  };
  releaseVideo = () => {
    if (this.state.services === undefined) return;
    const self = this;
    $(this.state.services).each(function() {
      const service = this;
      const id = 'video-' +service.service_id;
      if(Hls.isSupported()) {
        if (self.state.hlses[id] !== undefined) {
          //self.state.hlses[id].detachMedia();
          self.state.hlses[id].destroy();
        }
      }
    });
  }

  setupVideo = () => {
    if (this.state.setupVideo || !this.state.isMulti || this.state.services === undefined) {
      return;
    }
    const services = this.state.services;
    //const activeServiceId = this.props.activeServiceId;
    const xhrSetup = (xhr, url) => {
      if (url.indexOf('video.key') !== -1) {
        xhr.withCredentials = true;
        xhr.open('GET', url, true);
      }
      else if (url.indexOf('"') !== -1) {
        url = url.replace(/"/g, '');
        xhr.open('GET', url, true);
      }
    };
    const self = this;
    $(services).each(function() {
      const service = this;
      const id = 'video-' +service.service_id;
      let video = document.getElementById(id);
      let url = service.createChannelVideoUrl(service);
      if(Hls.isSupported()) {
        let multiHls = new Hls({
          xhrSetup: xhrSetup
        });
        self.state.hlses[id] = multiHls;
        multiHls.loadSource(url);
        multiHls.attachMedia(video);
        multiHls.on(Hls.Events.MANIFEST_PARSED, () => {
          let minBitrate = Number.MAX_VALUE;
          let minLevelIndex = undefined;
          multiHls.levels.forEach((level, index) => {
            if (level.bitrate < minBitrate) {
              minBitrate = level.bitrate;
              minLevelIndex = index;
            }
          });
          if (minLevelIndex) {
            multiHls.loadLevel = minLevelIndex;
            multiHls.startLoad();
          }
          video.play();
        });
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = url;
        video.addEventListener('loadedmetadata',function() {
          video.play();
        });
      }
    });
    this.setState({setupVideo: true});
  };

  render = () => {
    const services = this.state.services;
    if (services === undefined) {
      return (<div />);
    }
    const list = [];
    if (this.state.isMulti) {
      const activeService = this.props.service;
      const self = this;
      $(services).each(function() {
        const service = this;
        const isActive = service.service_id === activeService.service_id;
        const id = 'video-' +service.service_id;
        let className = "multi-video-item";
        if (isActive) {
          className += ' active';
        }
        list.push(
          <div
            className={className}
            onClick={evt => self.handleItemClick(service)}
          >
            <video
              id={id}
              autoPlay={true}
              playsInline={true}
              muted={true}
            ></video>
            <div className="multi-video-channel">{service.remote_control_key_id}</div>
          </div>
        );
      });
    }
    const fullscreenButtonStyle = {color:'white', minWidth: 40, display: this.state.isMulti? 'inline-block' : 'none'};
    const buttonStyle = {color:'white', position: 'absolute', top: 155, left: 0, minWidth: '40px'};
    if (!this.props.overlay) buttonStyle.display = 'none';
    return (
      <div style={{lineHeight:0}}>
        <IconButton
          onClick={this.handleMultiButtonClick}
          style={buttonStyle}
          onMouseEnter={this.handleMouseEnterOrMouseMove}
          onMouseMove={this.handleMouseEnterOrMouseMove}
          onMouseLeave={this.handleMouseLeave}
        >
          <AppsIcon />
        </IconButton>
        <div>
          <IconButton
            onClick={this.handleFullscreenButtonClick}
            style={fullscreenButtonStyle}
          >
            <FullscreenIcon />
          </IconButton>
          <IconButton
            onClick={this.handleCloseButtonClick}
            style={fullscreenButtonStyle}
            >
            <CloseIcon />
          </IconButton>
        </div>
        <div id="multi-video">
          {list}
        </div>
      </div>
    );
  };
};
export default MultiVideoArea;



// WEBPACK FOOTER //
// ./src/components/MultiVideoArea.js